// src/components/CustomerSummary/hooks/uiPrefsStorage.js
// ============================================================================
// BLOCK CS.HOOK.UI.STORE.0 — uiPrefs localStorage helpers
// ----------------------------------------------------------------------------
// IMPORTANT
// - localStorage is a fallback only.
// - The "shareable" source of truth is uiPrefs saved in your JSON payload.
// ============================================================================

const LS_KEY = 'CS:uiPrefs:v1';

function safeParseJson(s) {
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
}

function isObject(x) {
  return x !== null && typeof x === 'object' && !Array.isArray(x);
}

function normalizeUiPrefs(raw) {
  if (!isObject(raw)) {
    return null;
  }

  const tables = isObject(raw.tables) ? raw.tables : {};
  return { tables };
}

export function readUiPrefsFromLocalStorage() {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = window.localStorage.getItem(LS_KEY);
  if (!raw) {
    return null;
  }

  return normalizeUiPrefs(safeParseJson(raw));
}

export function writeUiPrefsToLocalStorage(uiPrefs) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeUiPrefs(uiPrefs) || { tables: {} };

  try {
    window.localStorage.setItem(LS_KEY, JSON.stringify(normalized));
  } catch {
    // ignore
  }
}
